<div class="selected-filters">
  <div class="selected-filters-header">
    <div class="header-left">
      <button
        *ngIf="!hideFilterToggle"
        type="button"
        class="toggle-filters-button"
        (click)="onToggleFilters()"
        [attr.aria-label]="translate('toggleFilters')"
        [attr.title]="translate('toggleFilters')"
      >
        <span class="material-symbols-outlined toggle-filters-icon" aria-hidden="true">
          {{ showFiltersPanel ? 'filter_list_off' : 'filter_list' }}
        </span>
      </button>
      <span class="results-summary" *ngIf="resultsSummaryText">{{ resultsSummaryText }}</span>
      <button
        *ngFor="let chip of chips"
        type="button"
        class="selected-filter-chip"
        [ngClass]="chip.cssClass"
        (click)="onRemoveChip(chip)"
        [attr.aria-label]="chip.facetTitle + ': ' + chip.label"
      >
        <span
          *ngIf="chip.icon"
          class="selected-filter-icon material-symbols-outlined"
          aria-hidden="true"
        >
          {{ chip.icon }}
        </span>
        <span *ngIf="chip.showLabel" class="selected-filter-label">{{ chip.facetTitle }}: {{ chip.label | capitalize }}</span>
        <span aria-hidden="true">×</span>
      </button>
    </div>

    <div class="header-right">
      <div class="sort-control">
        <label for="sort-select" class="sort-label">{{ translate('sortBy') }}:</label>
        <select id="sort-select" class="sort-select" (change)="onSortChange($event)">
          <option *ngFor="let option of sortOptions" [value]="option.value" [selected]="option.value === sort">
            {{ translate(option.labelKey) }}
          </option>
        </select>
      </div>

      <button *ngIf="chips.length" type="button" class="clear-filters-button" (click)="onClear()">
        {{ translate('clearFilters') }}
      </button>
    </div>
  </div>
</div>
